function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40z",
  fill: "#c00"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.656 15.985l-3.653 6.098a18.908 18.908 0 00-20.052 4.801c-7.315 7.669-7.104 19.889.47 27.294a18.904 18.904 0 0026.961-.476c4.397-4.61 6.075-10.863 5.069-16.727l6.551-2.609c1.907 8.39-.285 17.557-6.632 24.211a25.778 25.778 0 01-36.765.65C12.276 49.13 11.989 32.466 21.963 22.01a25.783 25.783 0 0128.693-6.024z",
  fill: "#fff"
});
function SvgProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgProcessing;